import { useState } from 'react';

import Link from 'next-translate-routes/link';

import { clsx } from 'clsx';

import { PrismicRichText } from '@prismicio/react';

import { PrismicNextImage } from '@prismic/components/PrismicNextImage';
import { linkResolver } from '@prismic/prismic-config';

import { Marker, IProps } from './types';
import * as S from './styles';

const getItemPosition = (marker: Marker) => ({
  top: `${marker.top}`,
  left: `${marker.left}`,
});

export const ImageMarker: React.FC<IProps> = ({ image, ...marker }: IProps) => {
  const [visible, setVisible] = useState(false);

  return (
    <S.Wrapper
      className={clsx('image-marker', {
        landscaped: image?.dimensions?.width >= image?.dimensions?.height,
        portrait: image?.dimensions?.width < image?.dimensions?.height,
      })}
    >
      {image && (
        <PrismicNextImage
          field={image}
          width={860}
          style={{ maxWidth: 'auto', height: '100%' }}
          sizes="(max-width: 1278px) 100vw, 33vw"
        />
      )}
      {marker.top && marker.left && (
        <>
          {marker?.link ? (
            <Link href={linkResolver(marker.link)} passHref>
              <a>
                <S.Marker
                  key="marker"
                  style={getItemPosition(marker)}
                  // onMouseOver={() => setVisible(!visible)}
                  // onMouseLeave={() => setVisible(!visible)}
                />
              </a>
            </Link>
          ) : (
            <S.Marker
              key="marker"
              style={getItemPosition(marker)}
              onMouseOver={() => setVisible(!visible)}
              onMouseLeave={() => setVisible(!visible)}
            />
          )}
          {visible && (
            <S.Overlay key="overlay" style={getItemPosition(marker)}>
              <S.Arrow />
              <S.Content>
                <PrismicRichText field={marker.text} />
              </S.Content>
            </S.Overlay>
          )}
        </>
      )}
    </S.Wrapper>
  );
};
